/**
 * Created by yniran on 12/14/14.
 */

//todo: monitor chat error to stop availability checks

define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEConfig = require("assets/config/le-env-conf"),
        ContactsAvailabilityCollection = require("connection-collections/chatTab/ContactsAvailabilityCollection"),
        ChatContactsAvailabilityController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        var logger = LEConnection.logger;
        var useFallback = LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.CHAT_FALLBACK_ENABLED, false) === "true";

        ChatContactsAvailabilityController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatContactsAvailabilityController");
                this._chatInitialized = false;
                this._chatChannel = options.chatChannel;
                this._availabilityIntervalHandlers = {};
                this._initializedFetchOptions = false;
                this._contextModel = options.contextModel;
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this._chatChannel.vent, "chatConnection:init", this._onChatInitialized);
            },


            _onChatInitialized: function () {
                logger.debug("chat initialized handler has been called", "ChatContactsAvailabilityController");
                this._chatInitialized = true;

                this.listenTo(this._contextModel.getContacts(), "sync add:fallbackContacts", this._onGroupsChange);  //now we can check for availability of contacts - groups
                if (this._contextModel.getContacts().length > 0) {  //if we have groups already here, lets check their availability
                    this._onGroupsChange();
                }

            },

            _retrieveContactsAvailabilityForChange: function (contactType, ids) {

                var retrieveFn = _.bind(this._retrieveContactsAvailabilityInfo, this, contactType, ids, true);

                this._availabilityIntervalHandlers[contactType] = setTimeout(retrieveFn, 200); //first time do quickly. after that use the configuration interval
            },

            _retrieveContactsAvailabilityInfo: function (contactType, ids, firstTime) {

                this._initializeAvailabilityRetrievalUrlOptions(_.bind(this._initAndFetchAvailabilityCollection, this, contactType, ids, firstTime));
            },

            _initAndFetchAvailabilityCollection: function (contactType, ids, firstTime) {

                if (this._initializedFetchOptions) {
                    var appKey = this._contextModel.getSupportAccountAppKey();
                    var fetchObject = {
                        success: _.bind(this._onContactsAvailabilityRetrieved, this, contactType, ids),  //ids can be reused all the time because we dont expect/support any addition or removal of users/groups during a session
                        error: _.bind(this._onContactsAvailabilityFail, this, contactType, ids)
                    };
                    this._retrieveAvailability(ids, contactType, appKey, fetchObject);
                }
                else {
                    logger.error("cannot initialize contacts availability URL  !!!! lpTag.getDomain() isnt available !!!!", "_initializeAvailabilityRetrievalUrlOptions");
                    logger.graph({name: "connection:ChatContactsAvailabilityController:_retrieveContactsAvailabilityInfo:fail"});
                }
            },

            _retrieveAvailability: function (ids, contactType, appKey, fetchObj) {

                var contactsAvailColl = new ContactsAvailabilityCollection({
                    ids: ids,
                    contactType: contactType,
                    appKey: appKey
                });

                contactsAvailColl.fetch(fetchObj);
            },

            _initializeAvailabilityRetrievalUrlOptions: function (readyCallback) {

                if (this._initializedFetchOptions) {
                    readyCallback();
                }
                else {
                    var maxAttempts = LEConfig.connectionPanelSettings.chat.visitorSessionMaxAttempts;
                    var attemptInterval = LEConfig.connectionPanelSettings.chat.visitorSessionRetryInterval;
                    var attemptCounter = 0;

                    var setMonitoringUrlVariables = _.bind(function () {
                        attemptCounter += 1;

                        this.availabilityMonitoringDomain = window.lpMTagConfig.lpServer;
                        this.availabilityMonitoringSite = this._contextModel.getSupportSiteId();

                        if (!this.availabilityMonitoringDomain && window.lpTag && window.lpTag.csds && _.isFunction(window.lpTag.csds.getDomain)) {
                            this.availabilityMonitoringDomain = window.lpTag.csds.getDomain("adminArea");
                        }

                        this._initializedFetchOptions = !_.isEmpty(this.availabilityMonitoringSite) && !_.isEmpty(this.availabilityMonitoringDomain);
                        if (!this._initializedFetchOptions) { //schedule another attempt
                            if (attemptCounter < maxAttempts) {
                                setTimeout(setMonitoringUrlVariables, attemptInterval);
                            } else {
                                this._initializedFetchOptions = true;
                                this._setUpFallbackOnly(readyCallback);
                            }
                        } else {
                            this._initializeFallbackAvailabilityRetrievalUrl(_.bind(this._updateMonitoringParameters, this, readyCallback));
                        }
                    }, this);

                    setMonitoringUrlVariables();
                }
            },

            _setUpFallbackOnly: function (readyCallback) {
                this._contextModel.switchChatMode();
                this.availabilityMonitoringSite = this._contextModel.getSupportSiteId();
                useFallback = false;

                this._retrieveSiteDomain(this.availabilityMonitoringSite, _.bind(function (domain) {
                    if (!_.isEmpty(domain)) {
                        this._loadPostMessageIfDomainIsNew(domain);
                        this.availabilityMonitoringDomain = domain;
                        this._updateMonitoringParameters(readyCallback);
                    }
                }, this));
            },

            _updateMonitoringParameters: function (callback) {
                LE.urlResolver.addConfigValue("supportAccountId", this.availabilityMonitoringSite); //inject the monitored account id so it can be used for the availability check
                LE.urlResolver.addConfigValue("monitoredAccountServer", this.availabilityMonitoringDomain);  //inject the monitored account server (app server domain) so its used for the availability check
                callback();
            },

            _initializeFallbackAvailabilityRetrievalUrl: function (callback) {
                var fallbackSiteId = LEConfig.connectionPanelChatSettings.fallbackSupportAccount.siteId;
                this._retrieveSiteDomain(fallbackSiteId, _.bind(function (domain) {

                    if (_.isEmpty(domain)) {
                        useFallback = false;
                        // TODO commented out do to failing build because of an error log... which is BAD!
                        // logger.error('could not find domain for fallback site: ' + fallbackSiteId, 'ChatContactsAvailabilityController');
                    } else {
                        this.fallbackAvailabilityMonitoringDomain = domain;
                        this._loadPostMessageIfDomainIsNew(domain);
                    }
                    callback();

                }, this));
            },

            _retrieveSiteDomain: function (siteId, callback) {
                var siteDomainRequest = {
                    site: siteId,
                    success: function (result) {
                        callback(result.domain);
                    },
                    error: function () {
                        callback();
                    }
                };
                lpTag.agent.getSiteDomain(siteDomainRequest);
            },

            _loadPostMessageIfDomainIsNew: function (domain) {
                if (domain !== this.availabilityMonitoringDomain) {
                    logger.debug('loading post message for domain: ' + domain, 'ChatContactsAvailabilityController');
                    lpTag.taglets.lpAjax.configureTransports({
                        postmessage: {
                            frames: [{
                                url: "https://" + domain + "/hcp/html/postmessage.min.html",
                                maxReloadRetries: 10
                            }]
                        }
                    });
                }
            },

            _onContactsAvailabilityRetrieved: function (contactType, ids, collection) {

                logger.debug("retrieved availability for type: " + contactType, "ChatContactsAvailabilityController", collection);
                this.trigger("chatContacts:availability:retrieved", {
                    contactType: contactType,
                    collection: collection
                });

                if (collection.allAgentsOffline && useFallback) {
                    this._checkOtherSupportAccount(contactType, ids);
                } else {
                    this._scheduleNextAvailabilityRetrieval(contactType, ids);
                }
            },

            _onContactsAvailabilityFail: function (contactType, ids, collection, response) {

                logger.error("failed to retrieve availability for type: " + collection.getContactTypes(), "ChatContactsAvailabilityController", response);
                if(useFallback) {
                    this._checkOtherSupportAccount(contactType, ids);
                }
            },

            _checkOtherSupportAccount: function (contactType, ids) {
                // we check if all agents are offline. if yes, then we switch account and reload the whole chat api
                var useFallback = this._contextModel.isNormalChatMode(); //use opposite siteId
                var fallbackSupportAccount = LEConfig.connectionPanelChatSettings.fallbackSupportAccount;
                var siteId = useFallback ? fallbackSupportAccount.siteId : LE.LPtag_mtaconfig.siteId;
                var domain = useFallback ? this.fallbackAvailabilityMonitoringDomain : this.availabilityMonitoringDomain;
                var appKey = useFallback ? fallbackSupportAccount.appKey : LEConfig.LPApiAppKey;

                this._switchMonitoringSite(domain, siteId);

                var fetchObj = {
                    success: _.bind(this._onOtherContactsAvailabilityRetrieved, this, contactType, ids),
                    error: _.bind(this._resetSiteIdAndRescheduleRetrieval, this, contactType, ids)
                };
                this._retrieveAvailability(ids, contactType, appKey, fetchObj);
            },

            _switchMonitoringSite: function (domain, siteId) {
                logger.debug('switch monitoring site to: ' + siteId + '  ' + domain, 'ChatContactsAvailabilityController');
                LE.urlResolver.addConfigValue("supportAccountId", siteId);

                var currentDomain = LE.urlResolver.getConfigValue("monitoredAccountServer");
                LE.urlResolver.addConfigValue("monitoredAccountServer", domain);
                this.currentMonitoredAccountServer = currentDomain;
            },

            _onOtherContactsAvailabilityRetrieved: function (contactType, ids, collection) {
                if (collection.allAgentsOffline) {
                    this._resetSiteIdAndRescheduleRetrieval(contactType, ids);
                } else {
                    this._contextModel.switchChatMode();
                    logger.info('chat mode switched to ' + (this._contextModel.isNormalChatMode() ? 'normal' : 'fallback'), 'ChatContactsAvailabilityController');
                    this._onContactsAvailabilityRetrieved(contactType, ids, collection);
                }
            },

            _resetSiteIdAndRescheduleRetrieval: function (contactType, ids) {
                var siteId = this._contextModel.getSupportSiteId();
                this._switchMonitoringSite(this.currentMonitoredAccountServer, siteId);
                this._scheduleNextAvailabilityRetrieval(contactType, ids);
            },

            _scheduleNextAvailabilityRetrieval: function (contactType, ids) {

                var interval = LEConfig.connectionPanelAvailabilityCheckInterval;
                var retrieveFn = _.bind(this._retrieveContactsAvailabilityInfo, this, contactType, ids, false);

                clearTimeout(this._availabilityIntervalHandlers[contactType]); //be nice and cleanup
                this._availabilityIntervalHandlers[contactType] = null;

                logger.debug("scheduling availability check for type: " + contactType + " in ms: " + interval, "ChatContactsAvailabilityController._scheduleAvailabilityRetrieval");
                this._availabilityIntervalHandlers[contactType] = setTimeout(retrieveFn, interval);
            },

            _onGroupsChange: function () {
                if (this._chatInitialized) {
                    logger.debug("chat groups collection changed", "ChatContactsAvailabilityController");
                    var skills = [];
                    _.each(this._contextModel.getContacts().models, function (model) {
                        if (!_.isUndefined(model)) {
                            //only add engagementSkills which are not messaging as we don't need availability there
                            if (!model.isMessagingContact()) {
                                skills.push(model.getSkillName());
                            }
                        }
                    });
                    if(skills.length>0){
                        this._retrieveContactsAvailabilityForChange(CP_CONST.CONTACT_TYPE.GROUP, skills);
                    }
                }
            }
        });
    });

    return ChatContactsAvailabilityController;
});
